package ru.it_mozaika.sender.js.application.routes

import oldframes.segments.newSegmentFrame
import oldframes.segments.segmentFrame
import oldframes.segments.oldSegmentsListFrame
import oldframes.segments.static.staticSegmentFrame
import js.core.jso
import react.Props
import react.create
import react.createElement
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.frames.segments.segmentsListFrame
import ru.it_mozaika.sender.js.application.frames.segments.static.staticSegmentsListFrame

val segmentsRoutes = jso<RouteObject> {
//    path = "/segments/*"
    path = "segments"
    children = arrayOf(
        jso {
            path = "static"
            children = arrayOf(
//                            Route {
//                                attrs.path = "/new"
//                                attrs.element = createElement { newSegmentFrame {
//                                    attrs.user = user
//                                    attrs.active = !isSidebarOpened
//                                } }
//                            }
                jso {
                    path = ":id"
                    element = createElement<Props> {
                        staticSegmentFrame {}
                    }
                },
                jso {
                    path = ""
                    index = true
                    element = staticSegmentsListFrame.create()
                //                    createElement<Props> {
//                        oldStaticSegmentsListFrame {}
//                    }
                }
            )

        },
        jso {
            path = "new"
            element = createElement<Props> {
                newSegmentFrame {}
            }
        },
        jso {
            path = ":id"
            element = createElement<Props> {
                segmentFrame {}
            }
        },
        jso {
            path = ""
            index = true
            element = segmentsListFrame.create()
//                createElement<Props> {
//                oldSegmentsListFrame {}
//            }
        }
    )
}
